import type { ChartResult } from '@astrally/shared';
import { ENGINE_VERSION } from './computeChart.js';

/**
 * Versioned chart serialisation for the local store. Charts persist with
 * their full calculation metadata so results remain auditable after engine
 * upgrades; a version mismatch signals the app to recalculate.
 */

export interface SerializedChart {
  formatVersion: 1;
  engineVersion: string;
  payload: ChartResult;
}

export function serializeChart(chart: ChartResult): string {
  const wrapper: SerializedChart = {
    formatVersion: 1,
    engineVersion: chart.meta.engineVersion,
    payload: chart,
  };
  return JSON.stringify(wrapper);
}

export function deserializeChart(json: string): {
  chart: ChartResult;
  staleEngine: boolean;
} {
  const parsed = JSON.parse(json) as SerializedChart;
  if (parsed.formatVersion !== 1 || !parsed.payload?.meta) {
    throw new Error('Unrecognised chart format');
  }
  return { chart: parsed.payload, staleEngine: parsed.engineVersion !== ENGINE_VERSION };
}
